import { useAuth0 } from '@auth0/auth0-react'

const CLAIM_KEY = 'https://pebbledash.co/status'

export default function TrialLockout({ children }) {
  const { user, isLoading } = useAuth0()

  if (isLoading || !user) {
    return <div>Loading...</div>
  }

  const status = user[CLAIM_KEY]

  if (status === 'expired') {
    return (
      <div className="h-screen flex flex-col items-center justify-center bg-gray-50">
        <div className="max-w-md text-center p-8 bg-white shadow-lg rounded-lg">
          <h1 className="text-2xl font-bold text-red-600 mb-4">Trial Expired</h1>
          <p className="mb-6 text-gray-600">
            Your 7-day trial has ended. To continue using Pebbledash, please upgrade to a Professional plan (£49/month).
          </p>
          <a
            href="https://buy.stripe.com/14A6oH1473N2bg78t404801"
            className="inline-block bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 font-medium"
          >
            Upgrade to Professional
          </a>
        </div>
      </div>
    )
  }

  return children
}
